export default "__VITE_ASSET__8b398019__"